import { motion } from "framer-motion";
import { ClipboardCheck, FileText, Hammer, ShieldCheck } from "lucide-react";

const STEPS = [
  {
    num: "01",
    icon: ClipboardCheck,
    title: "Sopralluogo Gratuito",
    desc: "Analisi termografica e strutturale della copertura esistente con rilievo dettagliato.",
  },
  {
    num: "02",
    icon: FileText,
    title: "Preventivo su Misura",
    desc: "Proposta tecnica chiara con capitolato dei materiali e computo metrico trasparente.",
  },
  {
    num: "03",
    icon: Hammer,
    title: "Esecuzione a Regola d'Arte",
    desc: "Cantiere in sicurezza con tecnici qualificati, ponteggi a norma e installazione rapida.",
  },
  {
    num: "04",
    icon: ShieldCheck,
    title: "Collaudo e Garanzia",
    desc: "Test di tenuta idrica, certificazioni di conformità e garanzia scritta di 20 anni.",
  },
];

export default function Process() {
  return (
    <section id="metodo" className="py-24 sm:py-32 bg-[#13151A] border-y border-white/5" data-testid="process-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="mb-16 max-w-3xl"
        >
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#D97736] mb-4">Il metodo</p>
          <h2 className="font-syne font-bold tracking-tight leading-tight text-3xl sm:text-4xl lg:text-5xl">
            Dal sopralluogo alla garanzia, in quattro mosse.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.num}
              data-testid={`process-step-${s.num}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="group relative bg-[#0B0C0E] border border-white/10 hover:border-[#D97736]/40 rounded-3xl p-7 transition-colors duration-500"
            >
              <div className="flex items-start justify-between mb-8">
                <span className="font-syne font-bold text-4xl text-white/10 group-hover:text-[#D97736]/40 transition-colors duration-500">
                  {s.num}
                </span>
                <s.icon size={26} className="text-[#D97736]" strokeWidth={1.6} />
              </div>
              <h3 className="font-syne font-semibold text-lg mb-3">{s.title}</h3>
              <p className="text-sm text-[#9CA3AF] leading-relaxed">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
